const paidReasonsValues = {
  paidOtherMean: 'paid_other_mean',
  paymentForgiven: 'payment_forgiven',
  other: 'other',
}
export const paidReasons = [
  {
    value: paidReasonsValues.paidOtherMean,
    label: 'Pagado manualmente por otro medio',
  },
  {
    value: paidReasonsValues.paymentForgiven,
    label: 'Pago perdonado',
  },
  {
    value: paidReasonsValues.other,
    label: 'Otro',
  },
]
